import "core-js/modules/es6.string.big.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibErrorModal',
  props: {
    big: {
      type: Boolean,
      default: true
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'negative'
    },
    iconColor: {
      type: String,
      default: ''
    },
    okButton: {
      type: Boolean,
      default: true
    },
    okButtonText: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    titleColor: {
      type: String,
      default: ''
    },
    note: {
      type: String,
      default: ''
    },
    noteColor: {
      type: String,
      default: '#868198'
    }
  },
  computed: {
    error: function error() {
      return this.$store.getters['errors/error'];
    },
    getBig: function getBig() {
      if (this.error && typeof this.error.big === 'boolean') {
        return this.error.big;
      }

      return typeof this.big === 'boolean' ? this.big : true;
    },
    getCloseButton: function getCloseButton() {
      if (this.error && typeof this.error.closeButton === 'boolean') {
        return this.error.closeButton;
      }

      return typeof this.closeButton === 'boolean' ? this.closeButton : true;
    },
    getIcon: function getIcon() {
      if (this.error && typeof this.error.icon === 'string') {
        return this.error.icon;
      }

      return this.icon || this.$t('common.button.ok');
    },
    getOkButton: function getOkButton() {
      if (this.error && typeof this.error.okButton === 'boolean') {
        return this.error.okButton;
      }

      return typeof this.okButton === 'boolean' ? this.okButton : true;
    },
    getOkButtonText: function getOkButtonText() {
      if (this.error && typeof this.error.okButtonText === 'string') {
        return this.error.okButtonText;
      }

      return this.okButtonText;
    },
    getTitle: function getTitle() {
      if (this.error && typeof this.error.title === 'string') {
        return this.error.title;
      }

      return this.title;
    },
    getNote: function getNote() {
      if (this.error && typeof this.error.note === 'string') {
        return this.error.note;
      }

      return this.note;
    },
    getStyles: function getStyles() {
      var defaultColour = this.color || this.themeStyle.dangerColor || '#D82770';
      var styles = {};
      var custom = ['iconColor', 'textColor', 'titleColor', 'noteColor'];

      for (var i in custom) {
        var style = custom[i];
        styles[style] = this[style] || defaultColour || '';

        if (this.error && typeof this.error[style] === 'string') {
          styles[style] = this.error[style];
        }
      }

      return styles;
    },
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    themeStyle: function themeStyle() {
      return {
        color: this.color || this.theme.dangerColor
      };
    }
  },
  methods: {
    handleInput: function handleInput(e) {
      if (!e) {
        this.close();
      }
    },
    close: function close() {
      if (this.error && this.error.onClose) {
        this.error.onClose();
      }

      this.$store.dispatch('errors/clearError');
    }
  }
};